<div class="preview-header">
  <div class="preview-title">
    <mat-icon class="title-icon">{{ isImage ? 'image' : 'picture_as_pdf' }}</mat-icon>
    <span class="filename" [title]="data.documentName">{{ data.documentName }}</span>
  </div>
  <div class="preview-toolbar">
    <button mat-icon-button matTooltip="Zoom Out" (click)="zoomOut()">
      <mat-icon>zoom_out</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Reset Zoom" (click)="resetZoom()">
      <mat-icon>zoom_in_map</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Zoom In" (click)="zoomIn()">
      <mat-icon>zoom_in</mat-icon>
    </button>
    <div class="divider"></div>
    <button mat-icon-button matTooltip="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="preview-body">
  @if (isImage) {
    <div class="image-container">
      <img
        [src]="imageSrc"
        [alt]="data.documentName"
        class="preview-image"
        [style.transform]="'scale(' + imageScale + ')'"
      />
    </div>
  } @else {
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [zoom]="pdfZoom"
      style="width: 100%; height: 100%; display: block;">
    </pdf-viewer>
  }
</div>
